module.exports = __webpack_public_path__ + "assets/images/project/people/girl-chart.png?v=2c345742";